import { combineReducers } from "@reduxjs/toolkit";

import {
	globalStateCustomerBalanceRuleDataState,
	globalStateCustomerBalanceRuleDataReducer,
	globalStateCustomerBalanceRuleDataAction,
} from "./data";

export type StateCustomerBalanceRule = {
	data: globalStateCustomerBalanceRuleDataState;
};

export const customerBalanceRule = combineReducers<StateCustomerBalanceRule>({
	data: globalStateCustomerBalanceRuleDataReducer,
});

export const globalStateCustomerBalanceRuleAction = {
	data: globalStateCustomerBalanceRuleDataAction,
};

export default customerBalanceRule;
